import { useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';

export default function LastThreeMonthsModifiedObligations({ elementID }) {
  const resLevel2 = useSelector(
    (state) => state.currentPage?.elementLevels?.level2?.[elementID]
  );
  const view = useSelector((state) => state.currentPage?.view);

  return (
    <AppRemixIcon
      icon="notification-2"
      color={
        resLevel2?.lastThreeMonthsModifiedObligations > 0
          ? colors.modifiedObligations
          : colors.grey400
      }
      filled={resLevel2?.lastThreeMonthsModifiedObligations > 0}
      title={
        resLevel2?.lastThreeMonthsModifiedObligations > 0
          ? view === 'resource'
            ? ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="new.obligations.latest.three.months"
                />
              )
            : ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="resource.new.modified.obligation.last.months"
                />
              )
          : ReactDOMServer.renderToString(
              <Translator
                file="module-resourceManager"
                name="resource.no.new.modified.obligations.last.months"
              />
            )
      }
    />
  );
}
